import { render, staticRenderFns } from "./allocation-manage-index.vue?vue&type=template&id=677c5d97"
import script from "./allocation-manage-index.vue?vue&type=script&lang=js"
export * from "./allocation-manage-index.vue?vue&type=script&lang=js"
import style0 from "./allocation-manage-index.vue?vue&type=style&index=0&id=677c5d97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports